export class NotificationCountRequest {
    userEmail: string;
    codesStatutNotif: number[];
}
